export default "__VITE_ASSET__BxrJreg2__"